<template>
    <div class="card-panel hoverable">
        <h4 class="card-title">Pending Tasks</h4>
        <div class="divider"></div>
        <div class="row">
            <div class="col s12 m12 l12">
                <span v-if="loadByUserId === 0 && isAdmin">Select a member to display.</span>
                <span v-else>
                    <span v-if="loading">Loading ...</span>
                    <div v-if="!hasData && !loading && !isAdmin">
                        <h6>You have not enough tasks data.</h6>
                        <a :href="createDiaryTaskUrl"
                           class="btn waves-light" style="margin-top: 15px">Create a Task</a>
                    </div>

                    <div v-if="!hasData && !loading && isAdmin">
                        <h6>No available tasks data for this member.</h6>
                    </div>
                </span>

                <canvas id="pendingTaskChart" v-show="!loading && hasData"></canvas>

            </div>
        </div>
        <div class="row mgb-0" v-if="!loading && hasData">
            <div class="col s6 m6 l6">
                <div class="number center-align">{{ c_ongoing }}</div>
                <div class="title center-align">Ongoing</div>
            </div>
            <div class="col s6 m6 l6">
                <div class="number center-align">{{ c_overdue }}</div>
                <div class="title center-align">Overdue</div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
      name: 'TaskSummary',

      props: [
        'dataUrl',
        'createDiaryTaskUrl',
        'haltInitiate',
        'isAdmin'
      ],

      data () {
        return {
          hasData: false,
          loading: true,
          data: [],
          loadedChart: null,
          loadByUserId: 0,

          c_ongoing: 0,
          c_overdue: 0
        }
      },

      mounted () {
        window.addEventListener('reload_pending_task', (payload) => {
          this.loadByUserId = payload.detail.user_id;
          this.load();
        });

        if (this.haltInitiate) {
          return;
        }

        this.load();
      },

      methods: {
        load() {
          this.loading = true;

          let data = '';

          if (this.loadByUserId > 0) {
            data += '?user_id=' + this.loadByUserId;
          }

          axios.get(this.dataUrl + data)
            .then(response => {

              this.loading = false;
              if((response.data.data.ongoing.count > 0 || response.data.data.overdue.count > 0) && response.data.success) {

                this.data = response.data.data;
                this.initChart();
                this.c_ongoing = this.data.ongoing.count;
                this.c_overdue = this.data.overdue.count;
                this.hasData = true;

              } else {
                this.hasData = false;
              }

            })
            .catch(err => {

              this.loading = false;
              M.toast({html: 'Error, loading pending tasks' + err, classes: 'red accent-2'});

            });
        },

        initChart()
        {
          let ctx2 = document.getElementById("pendingTaskChart");
          ctx2.height = 180;

          if (this.loadedChart) {
            this.loadedChart.destroy();
          }

          this.loadedChart = new Chart(ctx2, {
            type: 'pie',
            data: {
              labels: ["Overdue Tasks", "Ongoing Tasks"],
              datasets: [{
                label: '# of Tasks',
                data: [
                  this.data.overdue.count,
                  this.data.ongoing.count
                ],
                backgroundColor: [
                  '#84a3d8',
                  '#84d8b8'
                ]
              }],
              metadata: [
                this.data.overdue.diaries, // 0 = overdue
                this.data.ongoing.diaries, // 1 = ongoing
              ]
            },
            options: {
              legend: {
                display: false
              },
              tooltips: {
                callbacks: {
                  afterFooter: (tooltipItem, data) => {
                    return data.metadata[tooltipItem[0].index];
                  }
                }
              }
            }
          });
        }
      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/diaries/tasks/TaskSummary.vue